import { Card } from "antd";
import "./object-journals-skeleton.scss";

export const ObjectJournalsSkeleton = () => {
  return (
    <Card className="card-skeleton" style={{ padding: "12px", marginBottom: "16px" }}>
      <div className="row">
        <div className="placeholder address" />
      </div>
      <div className="row">
        <div className="placeholder date" />
      </div>
    </Card>
  );
};
